<template>
  <div class="home">
    <div class="bg" >
      <img :src="bg"/>
    </div>
    <div class="content">
      <div class="video">
          <div class="light"></div>
        <img src="../assets/bg_radio@3x.png"/>
        <div class="bar">
          <img class="bicon" src="../assets/img_screen@3x.png"/>
          <div id="jdt" :style="{width: jdt +'%'}" class="jdt"></div>
            <div  class="jdt-shadow"></div>
          <span class="left">{{music_count}}</span>
          <span class="right" >{{end_time}}</span>
        </div>
        <div class="music">
          <img class="zicon" @click="getDataFromApi(12345,1)" src="../assets/btn_previous@3x.png"/>
          <Music  :offPath="offPath" :onPath="onPath" :musicPath="musicPath"/>
          <img class="zicon" @click="getDataFromApi(12345,2)" src="../assets/btn_next@3x.png"/>
        </div>
      </div>
      <div class="title">{{title_w}}</div>
      <div class="title_desc">{{descA}}</div>
      <div class="desc">
        <!-- <div class="left">
          <div class="zls">
            文字 &nbsp;|&nbsp; {{zb}}
          </div>
          <div class="zls">
            声音 &nbsp;|&nbsp; {{gs}}
          </div>
          <div class="zls">
            背景音乐 &nbsp;|&nbsp; {{source}}
          </div>
        </div> -->
        <div class="right">
          <div class="icon-m">
            <img  v-for="(li, index) in icon"  :key="index" :src='li' class="icon">
          </div>
        </div>
        <div class="left">
          <div class="number">Vol.{{number}}</div>
        </div>
      </div>
    </div>
    <div class="cont" v-html="content">
    </div>
    <div class="ended" style="opacity: 0">
        <!-- <img  src="../assets/font.png"/> the end-->
        <p>收听完整内容</p><!-- @click="openA" -->
    </div>

    <div class="tg">
      <a target="view_window" href="https://mp.weixin.qq.com/s/gCWMZJSwQtS-w6hlY5jdfA" >诚邀投稿 >></a>
    </div>
    <Comment :commentData="comment_for_component"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import BScroll from 'better-scroll'
import Music from '@/components/music.vue'
import Comment from '@/components/comment.vue'

const mode = true // false 为打包成dev的

class Share {
  constructor ({ url, title, desc, pic, dataUrl = null }) {
    console.log('??')
    this.url = url
    this.title = title
    this.desc = desc
    this.pic = pic
    this.dataUrl = dataUrl // 第一次启动的是appInit
  }

  appShare () {
    const share_data = {
      type1: {
        title: this.title,
        desc: this.desc,
        link: this.url,
        imgUrl: this.pic,
        shareType: 1
      },
      type2: {
        title: this.title,
        link: this.url,
        imgUrl: this.pic,
        shareType: 2
      },
      type3: {
        imgUrl: '', // 空出来 不然优先分享图片
        shareType: 3
      }
    }
    document.getElementById('share').value = JSON.stringify(share_data)
    document.getElementById('share2').value = JSON.stringify(share_data.type1)
    document.getElementById('share3').value = JSON.stringify(share_data.type2)
  }

  callAppRouter (method, params={}, callback) {
    let req = {
      'Method': method,
      'Data': params
    }, cbName = `CB_${Date.now()}_${Math.ceil(Math.random() * 10)}`
    req = JSON.stringify(req)
    Xinchao.Web[cbName] = (err, result) => {
      if (callback) {
        callback(err, result)
      }
      delete Xinchao.Web[cbName]
    }
    if (/(iPhone|iPad|iPod)/i.test(navigator.userAgent)) {
      window.webkit.messageHandlers.XinchaoApp.postMessage({
        req,
        cbName
      })
    } else {
      XinchaoApp.callRouter(req, cbName)
    }
  }

  appGetName () {
    this.callAppRouter('isLogin', {}, (err, result) => {
      if (JSON.parse(result).msg === '已登录') {
        this.callAppRouter('Login', {}, (err, result) => {
          try {
            const r = JSON.parse(result)
            localStorage.setItem('name', r.data.name)
            console.log(r.data.name)
          } catch (e) {
            localStorage.setItem('name', result.data.name)
            console.log(result.data.name)
          }
        })
      }
    })
  }

  weiXinShare () {
    const that = this
    const message = {
      title: that.title,
      desc: that.desc,
      link: that.url,
      imgUrl: that.pic
    }
    if (this.dataUrl) {
      // message.type = 'music'
      // message.dataUrl = this.dataUrl
    }
    wx.ready(function (res) {
      wx.onMenuShareAppMessage(message)
      wx.onMenuShareQQ(message)
      wx.onMenuShareQZone(message)
      wx.onMenuShareTimeline(message)
      wx.error((res) => {
        // alert(res)
      })
    })
  }

  weiXinSDK (url, bl) {
    const getappid = new XMLHttpRequest()
    const that = this
    getappid.open('GET', url + '/web/v1/wechat/config?debug=1&url=' + encodeURIComponent(location.href.split('#')[0]))

    getappid.onreadystatechange = function () {
      if (getappid.readyState === 4 && getappid.status === 200) {
        console.log('sdk ok')
        let getSDK = JSON.parse(getappid.response)
        console.log(getSDK.data.wechat_config)
        getSDK.data.wechat_config.debug = false

        if (bl && !localStorage.getItem('name')) window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx632d4c99bd681cf3&redirect_uri=' + encodeURI(location.href.split('#')[0]) +'&response_type=code&scope=snsapi_userinfo#wechart_redirect'
        if (!bl || localStorage.getItem('name')) {
          wx.config(getSDK.data.wechat_config)
          that.weiXinShare()
          that.weiXinGetName(url)
        }
      }
    }
    getappid.send()
  }

  weatherCode () {
    const QRblock = /code=(.+?)&/
    const code = window.location.href.match(QRblock)
    sessionStorage.setItem('code', code)
    if (code) { return code } else {
      return false
    }
  }

  weiXinGetName (url) {
    if (!localStorage.getItem('name')) {
      console.log(code + 'asd你想要的' + sessionStorage.getItem('code'))
      const code = sessionStorage.getItem('code').replace(/code=/, '').replace(/\&.+/, '')

      $.get(url + '/web/v1/wechat/user', { code }, (data) => {
        console.log('jq都不行？'); console.log(data.data.nickname)
        localStorage.setItem('name', data.data.nickname)
      })
    }
  }

  weiXinInit (url) {
    const code = this.weatherCode()
    code ? this.weiXinSDK(url, false) : this.weiXinSDK(url, true)
  }

  appInit () {
    this.appShare()
    this.appGetName()
  }

  rawWeiXinShare (url) {
    const getappid = new XMLHttpRequest()
    const that = this
    getappid.open('GET', url + '/web/v1/wechat/config?debug=1&url=' + encodeURIComponent(location.href.split('#')[0]))
    getappid.onreadystatechange = function () {
      if (getappid.readyState === 4 && getappid.status === 200) {
        console.log('sdk ok')
        let getSDK = JSON.parse(getappid.response)
        console.log(getSDK.data.wechat_config)
        getSDK.data.wechat_config.debug = false

        wx.config(getSDK.data.wechat_config)
        that.weiXinShare()
      }
    }
    getappid.send()
  }

  rawGetName () {
    if (!localStorage.getItem('name')) {
      console.log(code + 'asd你想要的' + sessionStorage.getItem('code'))
      const code = sessionStorage.getItem('code').replace(/code=/, '').replace(/\&.+/, '')

      $.get(url + '/web/v1/wechat/user', { code }, (data) => {
        console.log('jq都不行？'); console.log(data.data.nickname)
        localStorage.setItem('name', data.data.nickname)
      })
    }
  }
}

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}

export default {
  name: 'home',
  data () {
    return {
      offPath: require('../assets/btn_play@3x.png'),
      onPath: require('../assets/btn_stop@3x.png'),
      musicPath: '',
      raw_content: '奥术大师大/n爱神的箭埃里克森的骄傲是考虑到大家阿里看见啊卡兰蒂斯/n就爱看is大家啊流口水的骄傲了圣诞节爱神的箭安联大厦/n',
      content: '',
      bg: '', // 就是那个最上的被剪切的玩意,
      music_count: '',
      jdt: '0',
      end_time: '',
      gs: '',
      zb: '',
      number: getQueryString('broadcast_id').replace(/#/, '').replace(/\//, ''),
      icon: [],
      title_w: '',
      period_id: '',
      next_id: '',
      get_url: 'https://api.psy-1.com',
      source: '',
      now_id: getQueryString('broadcast_id').replace(/#/, '').replace(/\//, ''),
      comment_for_component: []
    }
  },
  components: {
    HelloWorld,
    Music,
    Comment
  },
  methods: {
    openA () {
      this.$parent.aa()
    },
    getDataFromApi (id, change_action = 0) {
      console.log('测试服')
      let url = 'https://api.psy-1.com'
      if (process.env.NODE_ENV !== 'development') {
        url = 'https://api.psy-1.com'
      }
      if (mode === false) {
        url = 'https://api.psy-1.com'
      }
      // url = 'https://api.debug.psy-1.com'
      if (id === 12345) {
        id = this.period_id

      }
      // getQueryString('broadcast_id').replace(/#/, '').replace(/\//, '')
      $.get(url + '/web/v1/cosleep/broadcast/detail', { broadcast_id: id, change_action},
        (data)=>{
          if(data.status == 1) {
            this.comment_for_component = data.data.comment_list
            this.title_w = data.data.broadcast_title
            this.bg = data.data.broadcast_content_card
            this.source = data.data.broadcast_audio_source
            this.init(data.data.broadcast_audio_link)
            this.setFont(data.data.broadcast_content_text)
            this.icon = eval('(' + data.data.broadcast_icons + ')')
            this.period_id = data.data.broadcast_period
            this.number = data.data.broadcast_period
            this.now_id = data.data.broadcast_id
            this.zb = data.data.broadcast_author
            this.gs = data.data.broadcast_speaker
            this.descA = data.data.broadcast_share_info.desc
            console.log(data.data.broadcast_share_info.imgUrl +'dasdasda hehehe')
            console.log('???')
            const share = new Share( {pic: data.data.broadcast_share_info.imgUrl, url:data.data.broadcast_share_info.link, title: data.data.broadcast_share_info.title, desc: data.data.broadcast_share_info.desc})
            share.rawWeiXinShare(url)
            if (this.$store.getters.isApp) share.appInit()
          }else{
            this.$parent.aa2()
          }
        })
    },
    setFont (content) {
      this.content = content// '<p>'+content.replace(/\n/g, "</p><p>")
      console.log(this.content)
    },
    musicDetail () {
      const a = setInterval(() => {
        this.jdt = parseInt((document.querySelector('#myaudio').currentTime / document.querySelector('#myaudio').duration) * 100)
        this.end_time = this.musicCount(document.querySelector('#myaudio').duration)
        this.music_count = this.musicCount(document.querySelector('#myaudio').currentTime)
        console.log(this.jdt)
        if (this.jdt == '100') {
          console.log('wanbi')
          this.$parent.show = true
        }
      }, 500)
    },
    musicCount (value) {
      var secondTime = parseInt(value)// 秒
      var minuteTime = 0// 分
      var hourTime = 0// 小时
      if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
        // 获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60)
        // 获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60)
        // 如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          // 获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60)
          // 获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      let mark = ''
      if (parseInt(secondTime) < 10) {
        mark = '0'
      }
      var result = mark + parseInt(secondTime) + ' '

      let mark2 = '0'

      result = mark2 + parseInt(minuteTime) + ' : ' + result

      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + '小时' + result
      }
      return result
    },
    init (url) {
      this.musicPath = url
      document.querySelector('#myaudio').currentTime = 0
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.end_time = this.musicCount(document.querySelector('#myaudio').duration)
        },600)
        this.$children[0].rawPlay()
      })
      this.jdt = 0
    }
  },
  mounted () {
    console.log('?')
    const wrapper = document.querySelector('#app')
    const scroll = new BScroll(wrapper, {
      click: true,
      bounce: {
        top: false,
        bottom: false,
        left: false,
        right: false
      }
    })
    this.musicDetail()
    this.getDataFromApi(this.number)
  }
}
</script>

<style lang="scss" scoped>
  .home{
    position:relative;
    height: fit-content;
    background-color: rgba(255, 252, 248, 1);
    .bg {
      width:px2html(375px);
      height:px2html(214px);
      overflow: hidden;
      img {
        width:100%;
      }
    }
    .content {
      background-color: #fff;
      .video {
        position: absolute;
        top:px2html(-160px);
        left:px2html(22px);
        width:px2html(250px);
        height:px2html(150px);
        flex-direction: column;
        display: flex;
        justify-content: center;
        align-items: center;

        &>img{
          position: absolute;
          left:0px;
          top:0px;
          width:px2html(260px);
          height:px2html(135px);
        }
        .music {
          position:relative;
          z-index:999;
          display: flex;
          align-items: center;
          top:px2html(1px);
          right: px2html(-5px);
          .zicon {
            padding: 0px px2html(6px) 0px px2html(6px);
            position: relative;
            top: px2html(-2px);
            width:px2html(26px);
            height: px2html(26px);
          }
        }
        .bar {
          position: relative;
          right: px2html(-3px);
          top: px2html(-2px);
          width: px2html(220px);
          height: px2html(40px);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size:px2html(10px);
          .bicon{
            width:px2html(230px);
          }
          .jdt {
            position: absolute;
            top:50%;
            left:px2html(0px);
            z-index: 999;
            width:0%;
            height:px2html(1px);
            background-color: rgba(216, 216, 216, 1);
          }
            .jdt-shadow{
                position: absolute;
                top:50%;
                left:px2html(0px);
                z-index: 999;
                width:100%;
                height:px2html(1px);
                background-color: rgba(216, 216, 216, 0.2);
            }
          .jdt::after{
            position: absolute;
            right:px2html(-3px);
            top:px2html(-20px);
            content: '';
            background: url("../assets/img_point@3x.png");
            background-size: 100% 100%;
            z-index: 99999;
            height:px2html(40px);
            width:px2html(7px);
          }
          .left{
            position: absolute;
            left:px2html(1px);
            bottom:0px;
            color: #B7B7B7;
          }
          .right{
            position: absolute;
            right:px2html(1px);
            bottom:0px;
            color: #B7B7B7;
          }
        }
      }
      width: px2html(375px);
      position: relative;
      display:flex;
      background-color: rgba(255, 252, 248, 1);
      justify-content: center;
      &::before {
        border-top:px2html(136px) solid transparent;
        border-left:px2html(378px) solid rgba(255, 252, 248, 1);
        content: '';
        position:absolute;
        left:0px;
        top: px2html(-135px);
      }
      .title {
        position: absolute;
        left: px2html(28px);
        color:#57311E;
        font-size: px2html(20px);
        font-weight: 600;
      }
      .title_desc {
        position: absolute;
        top: px2html(40px);
        left: px2html(28px);
        color:#57311E;
        font-size: px2html(12px);
        font-weight: 600;
      }
      .desc{
        position: relative;
        top:px2html(58px);
        display: flex;
        width:px2html(320px);
        height: px2html(40px);
        border-bottom: px2html(1px) solid rgba(87, 49, 30, 0.2);
        justify-content: space-between;
        .left{
          width:px2html(160px);
          text-align: left;
          font-size:px2html(12px);
          color: #998174;
          .number {
            font-size:px2html(18px);
            color: rgba(87, 49, 30, 0.2);
            font-weight:400;
            position:absolute;
            right:0px;
            bottom: 0px;
            font-family: NotoSerifCJKsc;
          }
        }
        .right{
          width:px2html(160px);
          position: relative;

          .icon-m{
            position: absolute;
            left: 0px;
            bottom: px2html(-2px);
          }
          .icon {
            opacity: 0.6;
            -webkit-mask-image: -webkit-linear-gradient(top, #704c39, #795548);
            width:px2html(30px);
            height:px2html(30px);
            // background-color: rgba(255, 0, 0, 0.2);
          }
        }
      }
    }

    .cont {
      position: relative;
      top:px2html(80px);
      left: px2html(28px);
      font-size: px2html(14px);
      color: #57311E;
      width:px2html(320px);
      height: px2html(129px);
      overflow: hidden;
      padding-bottom: px2html(10px);
      text-align: justify;
      &::before {
        position: absolute;
        left: 0px;
        bottom: 0px;
        content: '';
        width: 100%;
        height: 50%;
        background: linear-gradient(rgba(255,255,255,0), rgba(255, 252, 248, 1));
      }
      p{
        margin-bottom: px2html(28px);
        text-align: justify!important;
      }
    }

    .ended{
      font-size: px2html(14px);
      height:px2html(330px);
      position:relative;
      top:px2html(100px);
      color: rgba(87, 49, 30, 0.2);
      font-family: NotoSerifCJKsc;
        text-align: center;
        img {
            width:px2html(89px);
            height:px2html(14px);
        }
        p{
            position:absolute;
            right:50%;
            top: 0%;
            transform: translateX(50%) translateY(50%);
            font-size:px2html(14px);
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(87, 49, 30, 0.6);
            border:px2html(1px) solid rgba(87, 49, 30, 0.6);
            border-radius: px2html(26px);
            width: px2html(120px);
            height: px2html(30px);
        }
    }
    .tg {
      font-size: px2html(12px);
      height:px2html(10px);
      position:relative;
      top:px2html(-155px);
      color: rgba(87,49,30,0.4);
      font-family: NotoSerifCJKsc;
    }
  }
</style>

<style lang="scss">
  .cont {
    position: relative;
    top:px2html(80px);
    font-size: px2html(14px);
    color: #998174;
  p{
    font-family: NotoSansCJKsc;
    margin-bottom: px2html(24px);
    text-align: justify;
  }
  }

  .light{
      z-index: 999;
      content:'';
      opacity: 0.2;
      position:absolute;
      right:px2html(4px);
      top:px2html(12px);
      width:px2html(5px);
      height:px2html(5px);
      background: url('../assets/light.png');
      background-size: 100% 100%;
  }

  .light-go{
      animation: mylight 2s infinite alternate;
      transition-timing-function: linear;
  }
  @keyframes mylight
  {
      from {opacity:0.2}
      to {opacity:1}
  }

  a,a:link,a:visited,a:hover,a:active{
    text-decoration: none;
    color:inherit;
  }

</style>
